import { PageContainer } from '@/components/Templates/PageContainer/PageContainer';
import { Header } from '@/contexts/NavigationContext/NavigationWrapper';
import styled from 'styled-components';
import { Logo } from './Logo';

export const EmptyNavigation = () => {
    return (
        <Header>
            <PageContainer>
                <StyledBar>
                    <StyledLogo />
                </StyledBar>
            </PageContainer>
        </Header>
    );
};

const StyledBar = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    height: var(--size-masthead-innerHeight);
`;

const StyledLogo = styled(Logo)`
    flex: initial;
`;
